/**
 * Admin-related constants for the application
 * Centralizes configuration values used across admin features
 */

/**
 * ADMIN_USER_ID - The user ID of the primary admin account
 * Used for filtering admin traffic from analytics and reports
 * @type {string}
 */
export const ADMIN_USER_ID = '1'

/**
 * MAX_TOOLTIP_USERS - Maximum number of users to display in chart tooltips
 * Prevents UI clutter when many users are active on a single day
 * @type {number}
 */
export const MAX_TOOLTIP_USERS = 5
